<div class="modal-shell">
  <div class="modal-header-row">
    <div>
      <h2 class="modal-title">Reset Password</h2>
      <p class="modal-subtitle">
        Verify OTP and set a new password to continue.
      </p>
    </div>
    <button type="button" class="close-btn" (click)="dissmissModal()" aria-label="Close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <form [formGroup]="forgotpassFormConfirm" (ngSubmit)="submit()" class="modal-form">
    <div class="form-field">
      <label>Confirmation Code</label>
      <p-inputOtp
        formControlName="otp"
        [length]="6"
        [integerOnly]="true"
        styleClass="otp-input">
      </p-inputOtp>
      <p class="countdown-text" *ngIf="timeLeft > 0">
        OTP expires in {{ timeLeft }}s
      </p>
      <p class="error-message" *ngIf="forgotpassFormConfirm.get('otp')?.invalid && forgotpassFormConfirm.get('otp')?.touched">
        Please enter a valid 6 digit OTP.
      </p>
    </div>

    <div class="form-field">
      <label for="newPassword">New Password</label>
      <div class="password-input">
        <input
          id="newPassword"
          [type]="hidePassword ? 'password' : 'text'"
          autocomplete="new-password"
          class="form-control"
          formControlName="newPassword"
          placeholder="Enter new password" />
        <button type="button" class="icon-btn" (click)="hidePassword = !hidePassword" aria-label="Toggle password visibility">
          <span class="material-icons">{{ hidePassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
      <p class="error-message" *ngIf="forgotpassFormConfirm.get('newPassword')?.invalid && forgotpassFormConfirm.get('newPassword')?.touched">
        Password must be at least 8 characters.
      </p>
    </div>

    <div class="captcha-container">
      <div class="captcha-background" [style.backgroundImage]="'url(' + noiseImage + ')'">
        <div
          *ngFor="let captcha of captchaText"
          [ngStyle]="captcha.style"
          class="captcha-character">
          {{ captcha.char }}
        </div>
        <button type="button" class="refresh-button" (click)="refreshCaptcha($event)">
          <i class="fa fa-refresh"></i>
        </button>
      </div>

      <div class="captcha-input">
        <input
          type="text"
          placeholder="Enter Captcha"
          formControlName="captcha"
          (input)="validateCaptcha($any($event.target).value)"
          maxlength="8"
          (paste)="onPaste($event)"
          class="captcha-text-input" />
        <div class="captcha-status">
          <span *ngIf="forgotpassFormConfirm.get('captcha')?.value && validCaptcha" class="valid-status">OK</span>
          <span *ngIf="forgotpassFormConfirm.get('captcha')?.value && !validCaptcha" class="invalid-status">X</span>
        </div>
      </div>
    </div>

    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="action-row">
      <button type="button" class="btn-secondary" (click)="dissmissModal()" [disabled]="isSubmitting">
        Cancel
      </button>
      <button
        type="submit"
        class="btn-primary"
        [disabled]="isSubmitDisabled || forgotpassFormConfirm.invalid || !validCaptcha || isSubmitting">
        {{ isSubmitting ? "Changing..." : "Change Password" }}
      </button>
    </div>
  </form>
</div>
